import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProductsSearchResults } from '@components/templates/marketplace';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';
import { useParams } from 'react-router';
import { useData } from '@hooks/useData';

export function ProductsSearchResultsPage() {
    const { searchQuery } = useParams();
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('products-search-component.metatags.title', {
            query: searchQuery,
            marketplace: allSettings?.data?.marketplaceName,
        }),
        description: t('products-search-component.metatags.description', {
            query: searchQuery,
            marketplace: allSettings?.data?.marketplaceName,
        }),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.productsSearch.replace(':searchQuery', `${searchQuery}`),
        index: true,
    });

    return (
        <FiltersProvider>
            <ProductsSearchResults searchQuery={searchQuery || ''} />
        </FiltersProvider>
    );
}
